/**
 * Site Header — Popover interactions
 *
 * Handles:
 * - Body scroll-lock when the mobile menu popover opens/closes
 * - Hamburger icon animation (X state) via JS class toggle
 *
 * The Popover API handles open/close/dismiss/Escape natively.
 *
 * @package TotalDigital
 */

const mobileMenu = document.getElementById('site-header-mobile');
const hamburger = document.querySelector('.site-header__hamburger');

if (mobileMenu && hamburger) {
	mobileMenu.addEventListener('toggle', (event) => {
		const isOpen = event.newState === 'open';

		// Lock / unlock body scroll
		document.documentElement.classList.toggle('noscroll', isOpen);
		document.body.classList.toggle('noscroll', isOpen);

		// Animate hamburger → X
		hamburger.classList.toggle('site-header__hamburger--is-open', isOpen);
		hamburger.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
	});
}
